import * as React from "react";

export function Delay(props: { children: any; delay?: number }) {
  const [isVisible, setIsVisible] = React.useState(false);
  React.useEffect(() => {
    const timerID = setTimeout(() => {
      setIsVisible(true);
    }, props.delay || 800);
    return () => {
      clearTimeout(timerID);
    };
  }, [props.delay]);
  if (!isVisible) {
    return null;
  }
  return props.children;
}
